import qs from "qs";

import type { QueryParams } from "../types";

/**
 * Creates a rails-readable querystring from an object
 *
 * @param params An object to be serialized into a query string
 */
export const encodeParams = (params: QueryParams): string => {
  return qs.stringify(params, { encode: true, arrayFormat: "brackets" });
};
